import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { dispatchEvent } from 'src/helpers/tagManager'
import { FormattedMessage } from 'react-intl'
import { AVMDiffClicked, AVMDiffLoad } from 'src/constants/trackingEvents'
import { toggleWarningModal } from 'src/actions/homeowner'

import { Button, Text } from 'src/Components'
import WarningModalLink from './WarningModalLink'
import WarningLayout from './WarningLayout'

import styles from './Warnings.module.scss'

const AVMDiffWarning = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatchEvent(AVMDiffLoad)
  }, [])

  return (
    <WarningLayout type='error'>
      <Text
        element='div'
        color='white'
        align='left'
        className={styles.calloutMessage}
      >
        <FormattedMessage
          id='Homeowner.estimatedValue.avmDiffWarning'
          defaultMessage='Your value has changed significantly since last month, which sometimes indicates an accuracy issue.'
        />{' '}
        <Button
          minimal
          onClick={() => dispatch(toggleWarningModal())}
          track={AVMDiffClicked}
        >
          <WarningModalLink />
        </Button>
      </Text>
    </WarningLayout>
  )
}

export default AVMDiffWarning
